import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "priorityInput"]
  static values = { current: String }

  static ACTIVE_CLASSES = "btn-ghost bg-accent/10"
  static INACTIVE_CLASSES = "btn-ghost text-fg-muted"

  select(event) {
    const button = event.currentTarget
    const newPriority = button.dataset.priorityParam
    const label = button.dataset.tooltipContentValue || newPriority

    if (newPriority === this.currentValue) return

    this.updateButtons(newPriority)

    this.priorityInputTarget.value = newPriority
    this.formTarget.requestSubmit()

    this.currentValue = newPriority

    window.dispatchEvent(
      new CustomEvent("toast:show", {
        detail: {
          message: `Priority set to ${label}`,
          type: "success"
        }
      })
    )
  }

  updateButtons(activePriority) {
    const buttons = this.element.querySelectorAll(".btn-group .btn")

    buttons.forEach((btn) => {
      const priority = btn.dataset.priorityParam

      btn.classList.remove(
        "btn-ghost",
        "btn-active",
        "text-fg-muted",
        "bg-accent/10"
      )

      const classes =
        priority === activePriority
          ? this.constructor.ACTIVE_CLASSES
          : this.constructor.INACTIVE_CLASSES
      classes.split(" ").forEach((cls) => btn.classList.add(cls))
    })
  }
}
